import { v4 as uuid } from 'uuid';
import { toPaletteColorName } from '@/features/colors/lib/paletteLookup';
import type { Category, CompleteCategory } from '../../types';

export const factory = (
  properties: Partial<Category> = {}
): CompleteCategory => {
  return {
    id: properties.id || uuid(),
    text: properties.text || null,
    colorName: toPaletteColorName(properties.colorName),
    sortOrder: properties.sortOrder || 0,
  };
};
